@if (getIsDestinyViewSelectorEnabled()) {
  <select
    #viewTypeSelect
    class="destiny-view-type"
    id="destinyViewTypes"
    [(ngModel)]="selectedViewType"
    (change)="setSelectedViewType(viewTypeSelect.value)"
    title="destinyViewTypes"
    >
    @for (dvt of viewTypes; track dvt) {
      <option [value]="dvt">View {{ dvt }}</option>
    }
  </select>
}
